<script>
  import {createEventDispatcher} from 'svelte';

  const dispatch = createEventDispatcher();

  export let total;
  export let current;
  export let limit = 10;
  export let type = '';
  export let model = '';

  $: totalPage = Math.ceil(total / limit);
  $: pageMid = genMidPage(current, totalPage, model);
  $: pageList = updataPageList(pageMid, current, totalPage, model);

  function genMidPage(page, totalPage, model) {
    if (model === 'phone') {
      let num = page - 1;
      if (page >= totalPage - 1) {
        num = totalPage - 3;
      }
      if (page <= 3) {
        num = 2;
      }
      const pages = [];
      for (let i = num; i < num + 3; i++) {
        pages.push({id: i, text: i, active: goToPage});
      }
      return pages;
    }
    let num = page - 2;
    if (page >= totalPage - 3) {
      num = totalPage - 5;
    }
    if (page <= 5) {
      num = 2;
    }
    const pages = [];
    for (let i = num; i < num + 5; i++) {
      pages.push({id: i, text: i, active: goToPage});
    }
    return pages;
  }

  function genTotalPage(page) {
    const pages = [];
    for (let i = 1; i <= page; i++) {
      pages.push({id: i, text: i, active: goToPage});
    }
    return pages;
  }

  function updataPageList(pageMid, current, totalPage, model) {
    if (model === 'phone') {
      return totalPage > 5 ? genAllPageActive(pageMid, current, totalPage, model) : genTotalPage(totalPage);
    }
    return totalPage > 8 ? genAllPageActive(pageMid, current, totalPage) : genTotalPage(totalPage);
  }

  function genAllPageActive(pageMid, current, totalPage, model) {
    if (model) {
      if (current > 3) {
        pageMid.unshift({id: -1, text: '•••', active: goToPage, direction: 'left'});
      }
      if (current < totalPage - 2) {
        pageMid.push({id: -2, text: '•••', active: goToPage, direction: 'right'});
      }
      pageMid.unshift({text: 1, active: goToPage, id: 1});
      pageMid.push({id: totalPage, text: totalPage, active: goToPage});
      return pageMid;
    }
    if (current > 5) {
      pageMid.unshift({id: -1, text: '•••', active: goToPage, direction: 'left'});
    }
    if (current < totalPage - 3) {
      pageMid.push({id: -2, text: '•••', active: goToPage, direction: 'right'});
    }
    pageMid.unshift({text: 1, active: goToPage, id: 1});
    pageMid.push({id: totalPage, text: totalPage, active: goToPage});
    return pageMid;
  }

  function goToPage(item) {
    let num = item.text ? item.text : item;
    if (item.direction === 'left') {
      num = current - 5 <= 1 ? 1 : current - 5;
    } else if (item.direction === 'right') {
      num = current + 5 >= totalPage ? totalPage : current + 5;
    }
    current = num;
    dispatch('change', {current: num});
  }
</script>

<style>
  .animationLeft {
    transform: rotate(90deg);
  }
  .animationRight {
    transform: rotate(270deg);
  }
  .arrow {
    color: #d9d9d9;
  }
  li {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    border: 1px solid #e6e9f0;
    border-radius: 4px;
    width: 30px;
    height: 30px;
    font-family: DINPro-Medium, DINPro;
    cursor: pointer;
    background: #fff;
    color: var(--T3);
  }
  li:hover,
  .active {
    background: var(--blue);
    color: #fff;
  }
  li .arrow {
    color: var(--T3);
  }
  li:hover .arrow {
    color: var(--blue);
  }
  .disabled,
  .disabled:hover {
    background: #fff;
    color: rgba(0, 0, 0, 0.25);
    pointer-events: none;
  }
  .disabled .arrow {
    color: rgba(0, 0, 0, 0.25);
  }
  .prev:hover,
  .next:hover {
    background: #e5e5e5;
  }
  .dark {
    width: 30px;
    height: 30px;
    background: #000;
    color: #e5e5e5;
  }
  .dark.prev:hover,
  .dark.next:hover {
    background: rgba(0, 0, 0, 0.85);
  }
  .dark.active {
    background: var(--blue);
    color: #fff;
  }
  .dark:hover .arrow {
    color: rgba(252, 252, 252, 0.5);
  }
  .dark .arrow {
    color: #e5e5e5;
  }
  .dark.disabled .arrow {
    color: var(--T2);
  }
</style>

<ul class="df fdr acc jcc">
  <li class="prev" class:disabled={current === 1} class:dark={type === 'dark'} on:click={goToPage(current - 1)}>
    <i class="iconfont arrow lh12 f14 animationLeft">&#xe623;</i>
  </li>
  {#each pageList as item (item.id)}
    <li class="f14 fw2" class:active={current === item.text} class:dark={type === 'dark'} on:click={() => item.active(item)}>{item.text}</li>
  {/each}
  <li class="next" class:disabled={current === totalPage} class:dark={type === 'dark'} on:click={goToPage(current + 1)}>
    <i class="iconfont arrow lh12 f14 animationRight">&#xe623;</i>
  </li>
</ul>
